import Link from '@root/joinroot.com/src/components/core/link';
import Responsive from '@root/core/src/utils/responsive';
import environment from '@root/core/src/utils/environment';
import headerCar from '@root/joinroot.com/src/assets/images/quote/car-2.png';
import headerCar2x from '@root/joinroot.com/src/assets/images/quote/car-2.png';
import headerGradient from '@root/joinroot.com/src/assets/images/quote/gradient.jpg';
import headerGradient2x from '@root/joinroot.com/src/assets/images/quote/gradient@2x.jpg';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { black, light, regular } from '@root/brand/src/assets/fonts/root-sans/emotion';

export default function QuoteHeaderLegacy() {
  const { trackClick } = useAnalytics('QUOTE_LANDING_HEADER', false);

  return (
    <section css={styles.section}>
      <div css={styles.wrap}>
        <div css={styles.content}>
          <h1 css={styles.h1}>Better drivers deserve <span css={styles.h1Span}>better&nbsp;</span>rates.</h1>
          <p css={styles.pSave}>You could save hundreds with&nbsp;Root.</p>
          <p css={styles.pQuote}>Get a free car insurance quote online&nbsp;now.</p>
          <Link
            css={styles.cta}
            onClick={() => trackClick('GET_A_QUOTE_BUTTON')}
            to={environment.quoteAppBaseUrl}
          >Get a quote
          </Link>
        </div>
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  section: {
    fontSize: 18,
    lineHeight: '1.5',
    color: '#404040',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    display: 'block',
    paddingBottom: '16vw',
    ...Responsive.lg({
      height: '90vh',
      maxHeight: '677px',
      paddingBottom: '130px',
    }),
    '&::before': {
      content: '\'\'',
      display: 'block',
      position: 'absolute',
      left: 0,
      width: '100%',
      top: 0,
      bottom: '16vw',
      ...Responsive.lg({
        bottom: '130px',
      }),
      backgroundImage: `url(${headerGradient})`,
      ...Responsive.x2({
        backgroundImage: `url(${headerGradient2x})`,
      }),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    },
  },
  wrap: {
    ...regular(),
    maxWidth: 1135,
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    top: 0,
    ...Responsive.lg({
      paddingBottom: '130px',
    }),
    '&::after': {
      display: 'block',
      position: 'absolute',
      paddingBottom: '40.9%',
      backgroundImage: `url(${headerCar})`,
      ...Responsive.x2({
        backgroundImage: `url(${headerCar2x})`,
      }),
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      content: '\'\'',
      left: '0',
      width: '100%',
      bottom: '-16vw',
      ...Responsive.lg({
        left: '200px',
        bottom: '0px',
        width: '1080px',
      }),
    },
  },
  content: {
    maxWidth: 740,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 'calc(29.2817679558px + 1vw * 5.5248618785)',
    textAlign: 'center',
    paddingBottom: '25vw',
    ...Responsive.lessThanLg({
      marginLeft: 'auto',
      marginRight: 'auto',
    }),
    ...Responsive.lg({
      textAlign: 'left',
      paddingTop: '100px',
      paddingBottom: '100px',
    }),
  },
  h1: {
    ...black(),
    margin: '0 0 0 0',
    lineHeight: 1,
    letterSpacing: '-0.05rem',
    fontSize: 'calc(27.5690607735px + 1vw * 3.3149171271)',
    ...Responsive.lg({
      fontSize: '70px',
    }),
    color: Colors.white(),
  },
  h1Span: {
    color: Colors.black(),
  },
  pSave: {
    ...light(),
    margin: '0 0 0 0',
    lineHeight: '1.5',
    letterSpacing: '-0.025rem',
    color: Colors.white(),
    fontSize: 'calc(23.7845303867px + 1vw * 1.6574585635)',
    ...Responsive.lg({
      fontSize: '45px',
    }),
  },
  pQuote: {
    margin: '0 0 0 0',
    lineHeight: '1.5',
    letterSpacing: '-0.025rem',
    color: Colors.white(),
    fontSize: '20px',
  },
  cta: {
    textDecoration: 'none',
    display: 'inline-block',
    color: Colors.white(),
    fontSize: '18px',
    lineHeight: '60px',
    padding: '0 30px',
    borderRadius: '10px',
    fontWeight: '600',
    transition: 'all 150ms cubic-bezier(0.37, 0, 0.28, 1)',
    backgroundColor: Colors.black(),
    paddingLeft: '40px',
    paddingRight: '40px',
    marginTop: 'calc(35.8563535912px + 1vw * 1.1049723757)',
    ...Responsive.lg({
      marginTop: '50px',
    }),
  },
});
